const dateTypesConstants = Object.freeze({
  CREATION_DATE: 'creation_date',
  EXPENSE_DATE: 'expense_date',
  CREATED_AT: 'created_at',
  SETTLEMENT_DATE: 'settlement_date',
});

export {dateTypesConstants};
